import type { BoxProps } from '@packages/shared';
import { Box } from '@packages/shared';

/**
 * Styled Box, which functions as overlay with an opaque background.
 */
export const Overlay = (props: { expanded: boolean } & BoxProps) => {
  const { expanded, ...other } = props;
  return (
    <Box
      {...other}
      sx={{
        height: '4rem',
        position: 'absolute',
        background:
          'linear-gradient(to top, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)',
        left: 0,
        bottom: 0,
        right: 0,
        willChange: 'opacity',
        opacity: expanded ? 0 : 1,
        transition: (theme) =>
          theme.transitions.create('opacity', {
            duration: theme.transitions.duration.short,
          }),
      }}
    />
  );
};
